export default __webpack_public_path__ + "static/ask-ai-customer-support-chatbot-d2f41d45a51e9978bffd9956e7d01a73.jpg";